import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {TransactionInfoService} from "../../../services/transaction-info.service";
import {ClaimTypes} from "../../../model/claim-type.model";

@Component({
    selector: 'app-hospitalization-helper',
    templateUrl: './hospitalization-helper.component.html',
    styleUrls: ['./hospitalization-helper.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HospitalizationHelperComponent implements OnInit {

    constructor( private transactionInfoService: TransactionInfoService) {
        this.transactionInfoService.getTransactionInfo().setCurrentClaimType(ClaimTypes[ClaimTypes.CLAIM_TYPE_DMH_HOSPITAL]);
    }

  ngOnInit() {
  }

}
